import _ from 'lodash'
import { MutationTree } from 'vuex'
import { Pager } from '@/store/pager.types'
import { MailTemplatesState, MailTemplate } from '@/store/mails/templates/types'

const mutations: MutationTree<MailTemplatesState> = {
  fetchedMailTemplates: (state, payload: {
    templates: MailTemplate[],
    pager: Pager,
  }) => {
    state.pager = payload.pager
    state.templates = payload.templates
  },

  gotMailTemplate: (state, template: MailTemplate) => {
    state.templates = _.uniqBy([
      template,
      ...state.templates,
    ], 'id')
  },
}

export default mutations
